<template>
  <div class="mb-5 pb-5">
    <div class="d-flex align-items-end">
      <h2 class="flex-grow-1">
        <font-awesome-icon icon="chart-pie"/>
        {{$t('global.menu.questions.myAnswers')}}
        <small class="text-muted">
          <span v-if="totalItems !== stats.total">{{totalItems}}/</span>{{stats.total}}
        </small>
      </h2>
      <b-btn v-b-toggle.filters variant="secondary">
        {{$t('userAnswers.stats.filters')}}
        <font-awesome-icon icon="chevron-down"/>
      </b-btn>
    </div>
    <b-collapse id="filters" @shown="showFilters">
      <Filters
        :default-filters="defaultFilters"
        ref="stats"
        base-answers-url="/current_user_answers"
        base-stats-url="/current_user_answer_stats"
        :stats="stats"
        store-method="userAnswer/list/getItems"
      />
    </b-collapse>
    <div class="row mt-3" v-if="items.length">
      <UserAnswerCard v-for="answer in items" v-bind:item="answer" :key="answer.id"></UserAnswerCard>
    </div>
    <p class="lead" v-else>{{$t('userAnswers.stats.empty')}}</p>
    <pagination v-bind:view="view" v-bind:getPage="getPage"></pagination>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import Pagination from '../app/Pagination';
import UserAnswerCard from './Card';
import Filters from '../app/Filters';


export default {
    components: {UserAnswerCard, Pagination, Filters},
    props: {
        defaultFilters: Object
    },
    computed: {
        ...mapGetters({
            items: 'userAnswer/list/items',
            totalItems: 'userAnswer/list/totalItems',
            loading: 'loading/loading/loading',
            view: 'userAnswer/list/view',
            stats: 'userAnswer/list/stats'
        })
    },
    methods: mapActions({
        getPage: 'userAnswer/list/getItems',
        showFilters() {
            this.$refs.stats.refresh();
        }
    }),
    beforeDestroy() {
        this.$store.dispatch('userAnswer/list/reset');
    }
};
</script>



// WEBPACK FOOTER //
// src/components/userAnswer/List.vue